import React from 'react';

function Section(props) {
  const {className, sectionId} = props;
  const newProps = {...props};
  delete newProps.className;
  delete newProps.sectionId;

  return (
    <div
      id={sectionId && `section-${sectionId}`}
      {...newProps}
      className={`mb-12 w-full ${className}`}
    >
      <h2 className='my-0'>{props.heading}</h2>
      <hr className='mb-4 border-gray-400' />
      {props.children}
    </div>
  );
}

export default Section;
